import { Spinner, SpinnerSize } from '@fluentui/react';
import { useEffect, useState } from 'react';

import { popup } from '../../../addons/Popup';
import { getAsync } from '../../../utils/api';
import { theme } from '../../../utils/theme';

export default ({
  formId,
  PDFDocumentId,
}: {
  formId: string;
  PDFDocumentId: string;
}) => {
  const [blobURL, setBlobURL] = useState<string>();

  useEffect(() => {
    getAsync(
      `/invoices/preview?formId=${formId}&PDFDocumentId=${PDFDocumentId}`
    )
      .then((blob: Blob) => {
        const url = URL.createObjectURL(blob);
        console.log(url);
        setBlobURL(url);
      })
      .catch((err) => {
        console.error(err);
        popup(
          "Önizleme yüklenirken hata meydana geldi, detaylı bilgi için konsola bakın"
        );
      });
  }, [formId, PDFDocumentId]);

  if (!blobURL) {
    return (
      <Spinner
        style={{
          marginTop: "6px",
          height: "calc(100vh - 56px)",
          width: "100%",
          backgroundColor: theme.palette.neutralLighter,
        }}
        size={SpinnerSize.large}
        label="Önizleme yükleniyor"
      />
    );
  } else {
    return (
      <iframe
        src={blobURL}
        style={{
          marginTop: "6px",
          width: "100%",
          height: "calc(100vh - 56px)",
          border: "none",
        }}
      >
        Tarayıcı önizleme desteklemiyor <a href={blobURL}>buraya tıklayın</a>.
      </iframe>
    );
  }
};
